// Mock Gemini service - returns simulated AI responses
const MOCK_RESPONSES = {
  default: {
    message: "I've analyzed your query within the current module context. Based on the ERP telemetry data, I recommend reviewing the recent transaction logs and verifying the system health metrics.",
    orchestration: {
      action: 'REPORT',
      target: 'System Health',
      payload: { scope: 'full_audit' },
    },
  },
  inventory: {
    message: "Stock levels are within acceptable thresholds. 2 items are flagged for reorder. I can generate a procurement suggestion or initiate an automatic restock workflow.",
    orchestration: {
      action: 'CREATE',
      target: 'Purchase Order',
      payload: { items: 2, priority: 'medium' },
    },
  },
  finance: {
    message: "Revenue is tracking 12.5% above forecast. I've identified 3 transactions pending reconciliation. Shall I auto-reconcile or flag for manual review?",
    orchestration: {
      action: 'UPDATE',
      target: 'Financial Records',
      payload: { pending: 3, action: 'reconcile' },
    },
  },
  fault: {
    message: "I've detected a latency spike in the us-east-1 region. The circuit breaker for the Finance-DB-Write service is approaching threshold. Recommend preemptive failover.",
    orchestration: {
      action: 'UPDATE',
      target: 'Circuit Breaker',
      payload: { node: 'Finance-DB-Write', action: 'failover' },
    },
  },
};

export const getGeminiResponse = async (prompt, contextModule) => {
  // Simulate API delay
  await new Promise((resolve) => setTimeout(resolve, 800 + Math.random() * 1200));

  const lowerPrompt = prompt.toLowerCase();

  if (lowerPrompt.includes('stock') || lowerPrompt.includes('inventory') || lowerPrompt.includes('reorder')) {
    return MOCK_RESPONSES.inventory;
  }
  if (lowerPrompt.includes('revenue') || lowerPrompt.includes('finance') || lowerPrompt.includes('money')) {
    return MOCK_RESPONSES.finance;
  }
  if (lowerPrompt.includes('fault') || lowerPrompt.includes('error') || lowerPrompt.includes('latency')) {
    return MOCK_RESPONSES.fault;
  }

  return {
    message: `Analyzing your request: "${prompt}" within the ${contextModule || 'General'} module context. ${MOCK_RESPONSES.default.message}`,
    orchestration: MOCK_RESPONSES.default.orchestration,
  };
};
